/**
 * Focus without scrolling ancestors to bring the element into view.
 * Needed for teleported menus (body-level): default focus() can scroll `.c-body` / perfect-scrollbar
 * and shift the layout so the header looks clipped or misaligned.
 */
export function focusWithoutScroll(element) {
  if (!element || typeof element.focus !== "function") {
    return
  }
  try {
    element.focus({ preventScroll: true })
  } catch {
    try {
      element.focus()
    } catch {
      /* detached */
    }
  }
}
